import type { TriageChoiceOption } from '@core/entities/Triage';

export type TriageDeferredOptionsGatewayErrorCode = 'offline' | 'request-failed' | 'retry-exhausted' | 'session-required';

export class TriageDeferredOptionsGatewayError extends Error {
  public constructor(
    public readonly code: TriageDeferredOptionsGatewayErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'TriageDeferredOptionsGatewayError';
  }
}

export interface TriageDeferredOptionsResult {
  items: readonly TriageChoiceOption[];
  nextCursor?: string;
}

export interface TriageDeferredOptionsGateway {
  getOptions(sourceListUrl: string, query?: string): Promise<TriageDeferredOptionsResult>;
}